import React from "react";
import "./Program_Structure.css";
import Accordion from "react-bootstrap/Accordion";

const semesterData = [
  {
    semester: "Semester 1",
    subjects: [
      "Computer Organization",
      "Programming using C",
      "Introduction to Applied Mathematics",
      "Introduction to IT",
      "Business English",
      "Management and Business Management",
    ],
  },

  {
    semester: "Semester 2",
    subjects: [
      "Data Structures Using C",
      "Discrete Mathematics",
      "Principles of Database Management System",
      "System Analysis and Design",
      "Lab Professional Version",
      "Linux Operating System",
    ],
  },

  {
    semester: "Semester 3",
    subjects: [
      "Digital Circuit Programming (C++)",
      "Advanced Database Management System",
      "Operating System",
      "Software Engineering",
      "RDBMS",
      "Advanced Web Technology",
    ],
  },

  {
    semester: "Semester 4",
    subjects: [
      "Advanced Web Technology",
      "Data Communication and Networks",
      "Web Technology",
      "Introduction to Python",
      "AI & ML Technology Using Python",
      "Business Laws and Regulations",
    ],
  },

  {
    semester: "Semester 5",
    subjects: [
      "Full Stack Web Development",
      "Fundamentals of Artificial Intelligence (AI)",
      "Big Data Analytics",
      "Natural Language Processing (NLP)",
      "Lab - Full Stack Web Development",
      "Generative AI and Prompt Engineering",
    ],
  },

  {
    semester: "Semester 6",
    subjects: [
      "Introduction to Android Development",
      "AI for Business Intelligence",
      "Computer Vision",
      "Lab - Android Development",
      "Cybersecurity / Indian Knowledge System",
      "Project Work - I",
    ],
  },
];

const Program_Structure = () => {
  return (
    <section className="SemesterAccordion">
      <div className="container">
        <div className="semester-inner">
          <div className="semester-heading">
            <span className="semester-small-title">Program Structure</span>
            <span className="semester-heading-line"></span>
          </div>

          <Accordion
            // defaultActiveKey={["0"]}
            className="semester-accordion"
          >
            <div className="row semester-row">
              {semesterData.map((semester, index) => (
                <div
                  className="col-lg-6 col-md-6 col-sm-6 col-12 semester-col mb-2"
                  key={semester.semester}
                >
                  <Accordion.Item
                    eventKey={String(index)}
                    className="semester-item"
                  >
                    <Accordion.Header>
                      <span className="semester-name">{semester.semester}</span>
                    </Accordion.Header>

                    <Accordion.Body>
                      <div className="semester-subjects">
                        {semester.subjects.map((subject, subjectIndex) => (
                          <div className="semester-subject" key={subjectIndex}>
                            <span className="subject-icon">✓</span>

                            <span className="subject-text">{subject}</span>
                          </div>
                        ))}
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </div>
              ))}
            </div>
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default Program_Structure;
